import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
    selector: "clare-message-box",
    templateUrl: "./message-box.component.html",
    styleUrls: ["./message-box.component.scss"],
})
export class MessageBoxComponent {
    @Input() actionTitle = "Confirm";
    @Input() dialogContent = "";
    @Input() isSaveIncluded = false;
    @Input() saveActionText = $localize`:@@SHARED.BTN.SAVE:Save`;
    @Input() data: unknown = null;

    @Output() saveClicked = new EventEmitter();
    @Output() cancelClicked = new EventEmitter();
}
